// extracted by mini-css-extract-plugin
export default {"modalHead":"FormHeader_modalHead__XKw-4"};